module.exports = __webpack_public_path__ + "static/media/icn_grid_view.f6449ce5.svg";